import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import SortOptions from "models/content-wrapper/sort-options";
import { DataModel } from "models/notificiations/websocket-message";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";
import { Subject } from "rxjs/Subject";
import { AuthService } from "../../app/auth/auth.service";
import { AlertSubscription } from "../../models/notificiations/alert-subscription";
import { AlertSubscriptionUpdate } from "../../models/notificiations/alert-subscription-update";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class AlertsDataService {
  public _alertsCount = new Subject<number>();
  public alertsCount = this._alertsCount.asObservable();
  public _dismissedAlert = new Subject<number>();
  public dismissedAlert = this._dismissedAlert.asObservable();
  public _newAlert = new Subject<object>();
  public newAlert = this._newAlert.asObservable();
  apiUrl: string;
  socketUrl: string;

  constructor(
    public http: HttpClient,
    public auth: AuthService,
    private config: ConfigurationService
  ) {
    if (config.getConfig().isLocal) {
      this.apiUrl = config.getConfig().localEndpoints.alertsUrl;
    } else {
      this.apiUrl = config.getConfig().apiUrl;
    }
  }

  public getAlerts(
    size: number = 20,
    sortOrder: number = 3,
    sortValue: string = "desc"
  ): Observable<DataModel> {
    return this.http.get<DataModel>(
      `${this.apiUrl}/alerts?size=${size}&sortOrder=${sortOrder}&sortValue=${sortValue}`
    );
  }

  public loadAlerts(
    size: number = 20,
    from: number = 0,
    sortOrder: number = 3,
    sortValue: string = "desc",
    categoryId: number
  ): Observable<DataModel> {
    return this.http.get<DataModel>(
      `${this.apiUrl}/alerts?categoryId=${categoryId}&size=${size}&from=${from}&sortOrder=${sortOrder}&sortValue=${sortValue}`
    );
  }

  public getAlertsByCategoryId(
    categoryId: number,
    sortOrder: number = 3,
    sortValue: string = "desc"
  ): Observable<DataModel> {
    return this.http.get<DataModel>(
      `${this.apiUrl}/alerts?categoryId=${categoryId}&sortOrder=${sortOrder}&sortValue=${sortValue}`
    );
  }

  public getAlertsCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/alerts/count`);
  }

  public updateFolder(folders: any[], updatedFolder: any): Observable<any> {
    const updatedFolders: any[] = folders.map((folder) => {
      if (folder.id === updatedFolder.id) {
        return updatedFolder;
      } else {
        return folder;
      }
    });
    return of(updatedFolders);
  }

  updateAlert(ids: number[], status: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/alerts/status-update`, {
      ids: ids,
      status: status.toUpperCase(),
    });
  }

  deleteAlertById(ids: number[]): Observable<any> {
    return this.http.patch(`${this.apiUrl}/alerts/delete`, { ids: ids });
  }

  deleteAllAlerts(categoryId: number = 0): Observable<any> {
    return this.http.patch(`${this.apiUrl}/alerts/delete`, {
      deleteAll: true,
      categoryId: categoryId,
    });
  }

  getAlertsSubscription(
    size: number = 20,
    from: number = 0
  ): Observable<AlertSubscription[]> {
    return this.http.get<AlertSubscription[]>(
      `${this.apiUrl}/alerts/subscriptions?size=${size}&from=${from}`
    );
  }

  getAlertsSubscriptionFilters(
    filters: string,
    sortOptions: SortOptions
  ): Observable<AlertSubscription[]> {
    const size: number = 20;
    const from: number = 0;
    return this.http.get<AlertSubscription[]>(
      `${this.apiUrl}/alerts/subscriptions?size=${size}&from=${from}${filters}&sortBy=${sortOptions.column}&sortValue=${sortOptions.direction}`
    );
  }

  updateAlertsSubscription(
    alertSubscriptionUpdate: AlertSubscriptionUpdate
  ): Observable<any> {
    return this.http.patch(
      `${this.apiUrl}/alerts/subscriptions`,
      alertSubscriptionUpdate
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/alerts-data-service/alerts-data-service.ts